export default __webpack_public_path__ + "static/media/iBridge360-logo.c1dfed0a.png";